// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
// import Vue from 'vue';
// import ElementUI from 'element-ui';
// import 'element-ui/lib/theme-chalk/index.css';
// import 'font-awesome/css/font-awesome.css';
import './css/common.scss';
import './css/reset.scss';
import App from './App';
import router from './router';
import store from './store/store';
import axios from './config/axios.config';
import cos from 'cos-js-sdk-v5';

Vue.prototype.cos = cos;
// import Moment from 'moment';
// import VueMoment from 'vue-moment';

Vue.config.productionTip = false;
// Vue.use(ElementUI);

import Croppa from 'vue-croppa';
Vue.use(Croppa);

// 复制到剪切板功能
import VueClipboard from 'vue-clipboard2';
Vue.use(VueClipboard);

// import mintConfig from './config/mint.config.js';
// mintConfig.install(Vue);

Vue.prototype.moment = moment;
// window.moment = Moment;
// window.moment.locale('zh-cn');
// Vue.use(VueMoment, Moment);

import MintUI from 'mint-ui';
import 'mint-ui/lib/style.css';
Vue.use(MintUI);


import editor from 'vue-quill-editor';
import 'quill/dist/quill.core.css';
import 'quill/dist/quill.snow.css';
import 'quill/dist/quill.bubble.css';
Vue.use(editor);
/* eslint-disable no-new */
new Vue({
    el: '#app',
    router,
    store,
    axios,
    components: {App},
    template: '<App/>'
});




// WEBPACK FOOTER //
// ./src/main.js